import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'applicationDeadline',
})
export class ApplicationDeadlinePipe implements PipeTransform {

  constructor() { }

  transform(value: string) {
    const m = moment(value);
    const today = moment(new Date().toISOString());
    if (m.toDate().getFullYear() !== today.toDate().getFullYear()) {
      return m.format(`M/D/YYYY`);
    } else {
      return m.format('MMM D');
    }
  }
}
